import React from "react";
import { Link } from "react-router-dom";
import { BrandMark } from "@/components/BrandMark";
import { ArrowRight, Cpu, Wrench, Users } from "lucide-react";

export default function Landing() {
  return (
    <div className="min-h-screen relative grain">
      <div className="relative z-10 max-w-6xl mx-auto px-6 md:px-10 py-10">
        <BrandMark />

        <div className="mt-20 md:mt-28 max-w-3xl">
          <div className="overline mb-6">IDEA · BUILD LAB · V1</div>
          <h1 className="font-heading font-light text-5xl md:text-7xl leading-[1.05] text-white">
            Watch your PC being <span style={{ color: "var(--accent)" }}>built live</span>.
          </h1>
          <p className="mt-6 text-white/60 max-w-xl text-lg leading-relaxed">
            A private, secure live-view session for every build. Assembled by hand at STATION 1 — streamed straight to your device.
          </p>
        </div>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-4">
          <RoleCard
            to="/admin/login"
            icon={<Cpu size={22} />}
            title="Supervisor"
            desc="Create orders, generate customer links"
            testId="role-admin"
          />
          <RoleCard
            to="/technician/login"
            icon={<Wrench size={22} />}
            title="Technician"
            desc="STATION 1 — start & finish builds"
            testId="role-technician"
          />
          <RoleCard
            to="/sales/login"
            icon={<Users size={22} />}
            title="Sales Team"
            desc="Customer pickup & component issues"
            testId="role-sales"
          />
        </div>

        <div className="mt-32 pt-8 border-t border-white/10 text-xs text-white/40 flex flex-wrap gap-4">
          <span>© IDEA · ideastore.global</span>
        </div>
      </div>
    </div>
  );
}

function RoleCard({ to, icon, title, desc, testId, disabled }) {
  const inner = (
    <div
      className="group p-6 rounded-sm border transition-colors h-full"
      style={{
        borderColor: "var(--border)",
        background: "var(--surface)",
      }}
    >
      <div className="flex items-center justify-between">
        <span
          className="w-10 h-10 rounded-sm flex items-center justify-center"
          style={{ background: "rgba(0,229,255,0.06)", color: "var(--accent)" }}
        >
          {icon}
        </span>
        {!disabled && (
          <ArrowRight
            size={18}
            className="opacity-40 group-hover:opacity-100 group-hover:translate-x-0.5"
            style={{ transitionProperty: "transform, opacity", transitionDuration: "200ms" }}
          />
        )}
      </div>
      <div className="mt-6 font-heading text-xl text-white">{title}</div>
      <div className="mt-1 text-sm text-white/50">{desc}</div>
    </div>
  );
  if (disabled) return <div data-testid={testId} className="opacity-50 cursor-not-allowed">{inner}</div>;
  return (
    <Link to={to} data-testid={testId} className="block hover:-translate-y-0.5" style={{ transitionProperty: "transform", transitionDuration: "200ms" }}>
      {inner}
    </Link>
  );
}
